import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CheckItemRecord } from "src/app/shared/models/focusDataModels/CheckItemRecord";
import { Discount } from "src/app/shared/models/focusDataModels/Discount";
import { EmployeeRecord } from "src/app/shared/models/focusDataModels/EmployeeRecord";
import { Job } from "src/app/shared/models/focusDataModels/Job";
import { MenuItemRecord } from "src/app/shared/models/focusDataModels/MenuItemRecord";
import { OrderType } from "src/app/shared/models/focusDataModels/OrderType";
import { ReportGroup } from "src/app/shared/models/focusDataModels/ReportGroup";
import { RevenueCenter } from "src/app/shared/models/focusDataModels/RevenueCenter";
import { SalesSummary } from "src/app/shared/models/focusDataModels/SalesSummary";
import { Tax } from "src/app/shared/models/focusDataModels/Tax";
import { AppService } from "./app.service";
import { FocusdataService } from "./focusdata.service";
import { FocuslinkService } from "./focuslink.service";
import { OOVenueService } from "./venue-service";

@Injectable({
	providedIn: "root",
})
export class ReportService {
	checkItems: BehaviorSubject<CheckItemRecord[]> = new BehaviorSubject<CheckItemRecord[]>([]);

	discounts: BehaviorSubject<Discount[]> = new BehaviorSubject<Discount[]>([]);

	employees: BehaviorSubject<EmployeeRecord[]> = new BehaviorSubject<EmployeeRecord[]>([]);

	jobs: BehaviorSubject<Job[]> = new BehaviorSubject<Job[]>([]);

	menuItemRecords: BehaviorSubject<MenuItemRecord[]> = new BehaviorSubject<MenuItemRecord[]>([]);

	orderTypes: BehaviorSubject<OrderType[]> = new BehaviorSubject<OrderType[]>([]);
	reportGroups: BehaviorSubject<ReportGroup[]> = new BehaviorSubject<ReportGroup[]>([]);
	revenueCenters: BehaviorSubject<RevenueCenter[]> = new BehaviorSubject<RevenueCenter[]>([]);

	salesSummary: BehaviorSubject<SalesSummary[]> = new BehaviorSubject<SalesSummary[]>([]);

	taxes: BehaviorSubject<Tax[]> = new BehaviorSubject<Tax[]>([]);

	constructor(public app: AppService, private focuslink: FocuslinkService, private focusdata: FocusdataService, private venueService: OOVenueService) {}

	init() {
		this.orderTypesGet();
		this.revenueCenterGet();
		this.reportGroupsGet();
	}

	async orderTypesGet() {
		const resp = await this.focusdata.orderTypesGet(this.venueService.venueKey);
		this.orderTypes.next(resp.map((i) => new OrderType(i)));
		return this.orderTypes.value;
	}

	async revenueCenterGet() {
		const resp = await this.focusdata.revenueCentersGet(this.venueService.venueKey);
		this.revenueCenters.next(resp.map((i) => new RevenueCenter(i)));
		return this.revenueCenters.value;
	}

	async reportGroupsGet() {
		const resp = await this.focusdata.reportGroupGets(this.venueService.venueKey);
		this.reportGroups.next(resp.map((i) => new ReportGroup(i)));
		return this.reportGroups.value;
	}

	async salesSummaryGet(checkDate: string) {
		if (!this.salesSummary.value.some((i) => i.CheckDate === checkDate)) {
			const resp = await this.focusdata.salesSummary(this.venueService.venueKey, checkDate);
			const summary = new SalesSummary(resp);
			this.salesSummary.value.push(summary);
			this.salesSummary.next(this.salesSummary.value);
		}

		return this.salesSummary.value.find((i) => i.CheckDate === checkDate);
	}

	async itemDataGetAll(checkDate: string, endDate?: string) {
		this.checkItems.next([]);

		const resp = await this.focusdata.itemSalesGetAll(this.venueService.venueKey, checkDate, true);
		this.checkItems.next(resp.map((i) => new CheckItemRecord(i)));
		if (endDate) {
			for (let currentDate = this.app.moment(checkDate, "MMDDYYYY"); currentDate.isSame(endDate, "MMDDYYYY"); currentDate.add(1, "day")) {
				const resp = await this.focusdata.itemSalesGetAll(this.venueService.venueKey, checkDate, true);
				this.checkItems.next(this.checkItems.value.concat(resp.map((i) => new CheckItemRecord(i))));
			}
		}
		return this.checkItems.value;
	}
}
